import styled from 'styled-components';

const ProgressLoaderWrapper = styled.div`
  display: flex;
	flex-direction:column;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
	position: absolute;
	top: 0px;
	bottom: 0px;
	background: var(--overlayBgColor);
	z-index: 999;
`;

const ProgressLoaderDiv = styled.div<{progress: number}>`
	width: 300px;
  height: 20px;
  background: rgba(0,0,0,0.4);
  border-radius: 4px;
	position: relative;


	.bar {
    height: 100%;
    width: ${({ progress }) => progress}%;
    background: var(--secondary);
    transition: width 0.3s ease;
  }
	
	.percent {
    position: absolute;
    top: -20px;
    right: 0;
    font-size: 20px;
    color: var(--primary);
    font-weight: 500;
  }

`;

const ProgressLoaderWrappers = styled.div<{ size: number }>`
 
  z-index: 9999; 
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;

  .text-container {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .label {
    font-size: 11px;
    color: var(--textColor);
    margin-bottom: 2px;
  }

  .value {
    font-size: 20px;
    font-weight: 700;
    color: var(--primary);
  }
`;

const LoaderSvg = styled.svg`
  transform: rotate(-90deg); /* Starts progress at 12 o'clock */

  .track {
    fill: none;
    stroke: var(--borderLightColor);
  }

  .progress {
    fill: none;
    stroke: var(--primary);
    stroke-linecap: round;
    transition: stroke-dashoffset 0.5s ease-in-out; /* Smoothly animates the bar */
  }
`;

export {
	ProgressLoaderDiv,
	ProgressLoaderWrapper,
	ProgressLoaderWrappers,
	LoaderSvg
};